<template>
  <ag-grid-vue
    style="width: 100%; height: 450px"
    class="ag-theme-alpine"
    :columnDefs="columnDefs"
    :rowData="rowData"
    :rowSelection="rowSelection"
    :setQuickFilter="updateSearchQuery"
    :gridOptions="gridOptions"
    @selection-changed="onSelectionChanged"
    @grid-ready="onGridReady"
    suppressDragLeaveHidesColumns
    suppressMovableColumns
    checkboxSelection="true"
  >
  </ag-grid-vue>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import iconEdit from "../Table/components/iconEdit.vue";
import btnConfirmlost from "../Table/components/btnConfirmlost.vue";
import moment from "moment";
import { mapGetters } from "vuex";

import { toShowAccountingPrice } from "../../util/accountingPrice";
export default {
  components: {
    AgGridVue,
    "table-iconEdit": iconEdit,
    btnConfirmlost,
  },
  data() {
    return {
      isSelectedAsset: false,
      columnDefs: null,
      rowSelection: "multiple",
      gridOptions: {
        rowHeight: 50,
        defaultColDef: {
          resizable: true,
        },
      },
      gridApi: "sizeColumnsToFit",
    };
  },
  props: {
    dataTable: [],
    searchText: {
      type: String,
    },
    otherColumn: [],
    page: { type: Number },
  },
  beforeMount() {
    let columnDefs = [
      {
        headerName: this.$t("count.order"),
        field: "index",
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        maxWidth: 110,
        suppressSizeToFit: true,
        getQuickFilterText: (params) => {
          return "";
        },
      },
      {
        headerName: this.$t("asset.fixedas_num"),
        field: "id_fixed_asset",
        sortable: true,
        suppressSizeToFit: true,
      },
      {
        headerName: this.$t("asset.as_name"),
        field: "name",
        sortable: true,
        minWidth: 200,
      },
      {
        headerName: this.$t("asset.as_dt"),
        field: "description",
        minWidth: 150,
      },
      {
        headerName: this.$t("asset.more_description"),
        field: "description2",
        minWidth: 200,
        hide: !this.canUseCustom8,
      },
      {
        headerName: this.$t("asset.as_cat"),
        field: "category",
        sortable: true,
        suppressSizeToFit: true,
      },
      {
        headerName: this.$t("asset.as_sub_cat"),
        field: "sub_category",
        sortable: true,
        suppressSizeToFit: true,
      },
      {
        headerName: this.$t("asset.location"),
        field: "asset_sector",
        sortable: true,
        suppressSizeToFit: true,
        hide: !this.canUseCustom2,
      },
      {
        headerName: this.$t("asset.branch"),
        field: "asset_branch",
        sortable: true,
        suppressSizeToFit: true,
        hide: !this.canUseCustom2,
      },
      {
        headerName: this.$t("home.as_loc"),
        field: "location",
        sortable: true,
        suppressSizeToFit: true,
      },
      {
        headerName: this.$t("home.as_stat"),
        maxWidth: 170,
        suppressSizeToFit: true,
        field: "asset_status",
        sortable: true,
        cellStyle: (params) => {
          if (
            params.value === this.$t("count.repar") ||
            params.value === this.$t("count.irrepar") ||
            params.value === this.$t("count.wait_as")
          ) {
            return { color: "#C18B00" };
          } else if (params.value === this.$t("count.not_reg")) {
            return { color: "#888888" };
          } else if (
            params.value === this.$t("count.lost") ||
            params.value === this.$t("filter.rep_lost")
          ) {
            return { color: "#FF0000" };
          } else if (params.value === this.$t("count.inuse")) {
            return { color: "#1E9400" };
          } else if (params.value === this.$t("home.regist")) {
            return { color: "#00AB1B" };
          }
          return null;
        },
      },
      {
        headerName: this.$t("home.note"),
        field: "note",
        sortable: true,
        minWidth: 150,
      },
      {
        headerName: this.$t("home.as_re"),
        field: "registrant",
        sortable: true,
        minWidth: 200,
      },
      {
        headerName: this.$t("btn.conf_lost"),
        field: "confirm_lost",
        maxWidth: 170,
        cellRendererFramework: "btnConfirmlost",
        getQuickFilterText: (params) => {
          return "";
        },
        suppressSizeToFit: true,
      },
      {
        headerName: this.$t("home.dt_manage"),
        field: "edit",
        cellRendererFramework: "table-iconEdit",
        maxWidth: 130,
        getQuickFilterText: (params) => {
          return "";
        },
        suppressSizeToFit: true,
      },
    ];
    if (!this.isRoleLower) {
      const fix_column = [
        {
          headerName: this.$t("asset.purchase_date"),
          field: "purchase_date",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.purchase_price"),
          field: "purchase_price",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.useful_life"),
          field: "useful_life",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.start_date"),
          field: "start_date",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.depreciation_today"),
          field: "acc_depreciation",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.net_book_today"),
          field: "net_book",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.insurance_start"),
          field: "insurance_start",
          sortable: true,
          suppressSizeToFit: true,
          hide: !this.canUseCustom2 || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.insurance_end"),
          field: "insurance_end",
          sortable: true,
          suppressSizeToFit: true,
          hide: !this.canUseCustom2 || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.vendor"),
          field: "vendor",
          sortable: true,
          suppressSizeToFit: true,
          hide: !this.canUseCustom2 || this.isRoleLower,
        },
      ];
      columnDefs = columnDefs.concat(fix_column);
    }

    this.columnDefs = columnDefs;
  },
  computed: {
    ...mapGetters({
      isRoleLower: "isRoleLower",
      permissionStatus: "permissionStatus",
      canUseDepreciation: "canUseDepreciation",
      canUseCustom2: "canUseCustom2",
      canUseCustom8: "canUseCustom8",
    }),
    rowData() {
      return this.dataTable.map((asset, index) => {
        let assetLocation = `${this.$t("asset.build")} ${
          asset.location_buildings ? asset.location_buildings.name : "-"
        } ${this.$t("asset.fl")} ${
          asset.location_floors ? asset.location_floors.name : "-"
        } ${
          this.canUseCustom8
            ? ` ${this.$t("asset.room")} ${asset.location_rooms?.name || "-"}`
            : ""
        } ${this.$t("asset.dep")} ${
          asset.location_departments ? asset.location_departments.name : "-"
        } ${this.$t("asset.zone")} ${
          asset.location_zones ? asset.location_zones.name : "-"
        }`;
        let dataShow = {
          id_fixed_asset: asset.id_fixed_asset,
          index: (this.page - 1) * 100 + index + 1,
          name: asset.name ? asset.name : "-",
          asset_status: this.checkAssetStatus(asset),
          description: asset.description ? asset.description : "-",
          description2: asset.description2 ? asset.description2 : "-",
          category: asset.categories ? asset.categories.name : "-",
          sub_category: asset.sub_category ? asset.sub_category.name : "-",
          location: assetLocation,
          registrant: asset.registrant ? asset.registrant : "-",
          note: asset.note ? asset.note : "-",
          purchase_date: asset.purchase_date
            ? this.momentDay(asset.purchase_date)
            : "-",
          purchase_price: asset.purchase_price
            ? toShowAccountingPrice(asset.purchase_price)
            : "-",
          useful_life: asset.useful_life ? asset.useful_life : "-",
          start_date: asset.start_date ? this.momentDay(asset.start_date) : "-",
          acc_depreciation: asset.acc_depreciation
            ? toShowAccountingPrice(asset.acc_depreciation)
            : "-",
          net_book: asset.net_book
            ? toShowAccountingPrice(asset.net_book)
            : "-",
          edit: asset.id_asset,
          confirm_lost: asset,
          asset_sector: asset.sector?.name || "-",
          asset_branch: asset.branch?.name || "-",
          insurance_start: asset.custom_start_time
            ? this.momentDay(asset.custom_start_time)
            : "-",
          insurance_end: asset.custom_end_time
            ? this.momentDay(asset.custom_end_time)
            : "-",
          vendor: asset.vendor?.name || "-",
        };
        const assetDetail = asset.asset_details;
        assetDetail.forEach((val) => {
          dataShow[`other_${val.column_no}`] = val.value || "-";
        });
        // console.log(asset);
        return dataShow;
      });
    },
  },
  watch: {
    searchText() {
      this.updateSearchQuery(this.searchText);
    },
    rowData() {
      this.loopHeaderFreeColumn();
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
  methods: {
    assetStatusTranslate(text) {
      switch (text) {
        case "available":
          return this.$t("count.inuse");
        case "unavailable":
          return this.$t("count.not_inuse");
        case "broke":
          return this.$t("count.defect");
        case "maintain":
          return this.$t("count.repairing");
        case "cannot_repair":
          return this.$t("count.irrepar");
        default:
          return "";
      }
    },
    checkAssetStatus(asset) {
      let status = "-";
      if (asset.date_regis) {
        status = this.$t("home.regist");
      } else {
        status = this.$t("asset.not_reg");
      }

      if (asset.asset_status) {
        status = this.assetStatusTranslate(asset.asset_status)
      }


      if (asset.is_lost === "lost") {
        status = this.$t("count.lost");
      }
      if (asset.is_lost === "report") {
        status = this.$t("filter.rep_lost");
      }
      return status;
    },
    loopHeaderFreeColumn() {
      let columnDefs = [
        {
          headerName: this.$t("count.order"),
          field: "index",
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          maxWidth: 110,
          suppressSizeToFit: true,
          getQuickFilterText: (params) => {
            return "";
          },
        },
        {
          headerName: this.$t("asset.fixedas_num"),
          field: "id_fixed_asset",
          sortable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: this.$t("asset.as_name"),
          field: "name",
          sortable: true,
          minWidth: 200,
        },
        {
          headerName: this.$t("asset.as_dt"),
          field: "description",
          minWidth: 150,
        },
        {
          headerName: this.$t("asset.more_description"),
          field: "description2",
          minWidth: 200,
          hide: !this.canUseCustom8,
        },
        {
          headerName: this.$t("asset.as_cat"),
          field: "category",
          sortable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: this.$t("asset.as_sub_cat"),
          field: "sub_category",
          sortable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: this.$t("asset.location"),
          field: "asset_sector",
          sortable: true,
          suppressSizeToFit: true,
          hide: !this.canUseCustom2,
        },
        {
          headerName: this.$t("asset.branch"),
          field: "asset_branch",
          sortable: true,
          suppressSizeToFit: true,
          hide: !this.canUseCustom2,
        },
        {
          headerName: this.$t("home.as_loc"),
          field: "location",
          sortable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: this.$t("home.as_stat"),
          maxWidth: 170,
          suppressSizeToFit: true,
          field: "asset_status",
          sortable: true,
          cellStyle: (params) => {
            if (
              params.value === this.$t("count.repar") ||
              params.value === this.$t("count.irrepar") ||
              params.value === this.$t("count.wait_as")
            ) {
              return { color: "#C18B00" };
            } else if (params.value === this.$t("count.not_reg")) {
              return { color: "#888888" };
            } else if (
              params.value === this.$t("count.lost") ||
              params.value === this.$t("filter.rep_lost")
            ) {
              return { color: "#FF0000" };
            } else if (params.value === this.$t("count.inuse")) {
              return { color: "#1E9400" };
            } else if (params.value === this.$t("home.regist")) {
              return { color: "#00AB1B" };
            }
            return null;
          },
        },
        {
          headerName: this.$t("home.note"),
          field: "note",
          sortable: true,
          minWidth: 150,
        },
        {
          headerName: this.$t("home.as_re"),
          field: "registrant",
          sortable: true,
          minWidth: 200,
        },
        {
          headerName: this.$t("btn.conf_lost"),
          field: "confirm_lost",
          maxWidth: 170,
          cellRendererFramework: "btnConfirmlost",
          getQuickFilterText: (params) => {
            return "";
          },
          suppressSizeToFit: true,
        },
        {
          headerName: this.$t("home.dt_manage"),
          field: "edit",
          cellRendererFramework: "table-iconEdit",
          maxWidth: 130,
          getQuickFilterText: (params) => {
            return "";
          },
          suppressSizeToFit: true,
        },
        {
          headerName: this.$t("asset.purchase_date"),
          field: "purchase_date",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.purchase_price"),
          field: "purchase_price",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.useful_life"),
          field: "useful_life",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.start_date"),
          field: "start_date",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.depreciation_today"),
          field: "acc_depreciation",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.net_book_today"),
          field: "net_book",
          sortable: true,
          minWidth: 150,
          suppressSizeToFit: true,
          hide: !this.canUseDepreciation || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.insurance_start"),
          field: "insurance_start",
          sortable: true,
          suppressSizeToFit: true,
          hide: !this.canUseCustom2 || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.insurance_end"),
          field: "insurance_end",
          sortable: true,
          suppressSizeToFit: true,
          hide: !this.canUseCustom2 || this.isRoleLower,
        },
        {
          headerName: this.$t("asset.vendor"),
          field: "vendor",
          sortable: true,
          suppressSizeToFit: true,
          hide: !this.canUseCustom2 || this.isRoleLower,
        },
      ];
      let column = this.otherColumn;
      for (const col of column) {
        let header = {
          headerName: col.name,
          field: `other_${col.column_no}`,
          maxWidth: 130,
          cellRenderer: (params) => {
            return params.value || "-";
          },
          suppressSizeToFit: true,
        };
        columnDefs.push(header);
      }

      this.columnDefs = columnDefs;
    },
    onGridReady() {
      this.gridApi.sizeColumnsToFit();
      this.$emit("set-watcher");
    },
    momentDay(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    onSelectionChanged() {
      this.isSelectedAsset =
        this.gridApi.getSelectedNodes().length !== 0 ? true : false;
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
      this.gridApi.refreshCells();
    },
    getSelectedRowData() {
      let selectedNodes = this.gridApi.getSelectedNodes();
      let selectedData = selectedNodes.map((node) =>
        this.dataTable.find(
          (asset) => asset.id_fixed_asset === node.data.id_fixed_asset
        )
      );
      return selectedData;
    },
  },
  updated() {
    this.onSelectionChanged();
  },
};
</script>

<style scoped>
* >>> .ag-header-cell-label {
  justify-content: center;
}
* >>> .ag-header-row-column {
  background: transparent linear-gradient(180deg, #007afe 0%, #013f81 100%);
  color: white;
}
</style>
